module.exports = __webpack_public_path__ + "static/media/mexican_restaurant_mural_concept_classic_cartoon_style_2017.388c84d5.webp";